import { User, UserAut } from "../interfaces/user-interfaces";

export const userVacio: User = {
    uid: '',
    nombre: '',
    cedula: '',
    contacto: '',
    telfContacto: '',
    dirUsr: '',
    email: '',
    acepto: false,
    fechaHora: '',
    foto: '',
    tipoUsuario: 'Usuario',
    extraSize: '0px'
};

export const userAutVacio: UserAut = {
    uid: '',
    email: '',
    autorizado: 'N',
    nombre: '',
    cedula: '',
    contacto: '',
    telfContacto: '',
    dirUsr: '',
    acepto: false,
    fechaHora: ''
};

export const userPrueba: User = {
  uid: 'id de usuario, ej: simplelogin:1',
  nombre: 'Smarttec Cia. Ldta.',
  cedula: '1791278046001',
  contacto: 'Usuario de prueba',
  telfContacto: '2233445/2587963',
  dirUsr: 'Av. de la Prensa N65-756 y Av. del Maestro',
  email: 'correo@mail.com',
  acepto: false,
  fechaHora: '2022/06/13-17:30:00:000',
  foto: '',
  tipoUsuario: 'Usuario',
  extraSize: '0px'
};

//aquí también puede haber
//export let xxx: tipo = ....
//export function jdfkjshd()



